import React from 'react';
import {Redirect, Route} from "react-router-dom";
import {RouteComponentProps, StaticContext} from "react-router";
import {useSelector} from "react-redux";
import {StateType} from "../store/store";

type RouteProps = {
  [x: string]: any,
  component: React.ComponentType<any> | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>
}

export default function StudentPrivateRoute({component: Component, ...rest}: RouteProps) {
  const studentState = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const {data} = studentState;
  return (
    <Route
      {...rest}
      render={(props =>
          data.role === "student" ? (
            <Component {...props} />
          ) : (
            <Redirect to={{pathname: "/auth"}}/>
          )
      )}
    />
  )
}